import { render, staticRenderFns } from "./otpDashboardModule.vue?vue&type=template&id=09e1a2e8&scoped=true"
import script from "./otpDashboardModule.vue?vue&type=script&lang=js"
export * from "./otpDashboardModule.vue?vue&type=script&lang=js"
import style0 from "./otpDashboardModule.vue?vue&type=style&index=0&id=09e1a2e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e1a2e8",
  null
  
)

export default component.exports